import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client/react';


const qry = gql`mutation WriteToDB($recs_to_write: [String!]!) {
  WriteToDB(recs_to_write: $recs_to_write) 
}`;

var DBValues = [];

export function initializeDBValues(dbData) {
    if (!dbData || dbData.length <= 0) {
        return;
    }
    DBValues = [];

    for (let oneRec of dbData) {
        if (oneRec && oneRec.rownum && oneRec.rownum > 0 && oneRec.rownum < 1000) {
            const { __typename, ...rest } = oneRec;
            DBValues.push({
                rownum: oneRec.rownum,
                rowdata: rest,
                userinput: {}
            });
        }
    }

    console.log(DBValues);
}

export function maintainValue(rowData, isChecked) {
    if (!isChecked) {
        delete DBValues[rowData.rownum];
    } else {
        DBValues[rowData.rownum] = { rowdata: rowData, ischecked: isChecked };
    }

    console.log("IN DB VALUES -> ", DBValues);
}

export function UploadButton() {
    const [mutateFunction, { data, loading, error }] = useMutation(qry);

    const handleSubmit = async () => {
        try {
            let recsToWrite = [];
            for (let oneRec of DBValues) {
                recsToWrite.push(JSON.stringify(oneRec));
            }
            const result = await mutateFunction({
                variables: { recs_to_write: recsToWrite }
            });
            console.log('Mutation successful:', result.data);
        } catch (err) {
            console.error('Mutation error:', err);
        }
    };

    return (
        <button class="upload-button" type="submit" value="Upload" onClick={handleSubmit} disabled={loading}>Upload </button>
    );
}
